import HealthManagerDeathsavesGroup from "./HealthManagerDeathsavesGroup";

export default HealthManagerDeathsavesGroup;
export { HealthManagerDeathsavesGroup };
